import { v4 as uuidv4 } from 'uuid';

const accordionData = [
    {
        id: uuidv4(),
        question: 'What services does ProtoPath offer?',
        answer: 'ProtoPath specialises in rapid prototyping, CAD design, 3D scanning, product design, industrial equipment design, component manufacturing, sourcing and plating, as well as comprehensive manufacturing consulting including production optimisation and ISO conformance.',
    },

    {
        id: uuidv4(),
        question: 'Do you service clients across Australia?',
        answer: 'Yes! ProtoPath is proudly Australian-based and provides nationwide service to clients across all states and territories. We understand local industry requirements and Australian standards.',
    },

    {
        id: uuidv4(),
        question: 'How does ProtoPath ensure quality in manufacturing?',
        answer: 'We maintain rigorous quality assurance through ISO-compliant processes, precision engineering standards, and comprehensive validation procedures. Our Australian-based team ensures all projects meet or exceed local and international quality benchmarks.',
    },

    {
        id: uuidv4(),
        question: 'What is the typical turnaround time for prototypes?',
        answer: 'Turnaround times vary based on project complexity and specifications. Our rapid prototyping capabilities allow us to deliver quick results without compromising quality. Contact us to discuss your specific timeline requirements.',
    },

    {
        id: uuidv4(),
        question: 'Can ProtoPath help with ISO conformance and compliance?',
        answer: 'Absolutely. We offer comprehensive ISO conformance consulting to help your business meet Australian and international standards. Our expertise includes process documentation, quality management systems, and compliance auditing.',
    },
];

export default accordionData;
